import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 40,
  flexWrap: 'wrap',
  paddingTop: 20,
  maxHeight: 200,
  overflow: 'auto',
  alignItems: 'flex-start',

  [theme.breakpoints.down('sm')]: {
    maxHeight: 400,
  },
}));

export const ProfileItemContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  gap: 5,

  '&:hover': {
    opacity: 0.9,
  },
});

export const ProfileItemPicContainer = styled('div')(({ theme }) => ({
  width: 101,
  height: 139,
  backgroundColor: theme.palette.type === 'dark' ? '#0a0b15' : '#fff',
  borderStyle: 'solid',
  borderWidth: '1px',
  // borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
  // backgroundImage:
  //   theme.palette.type === 'dark'
  //     ? 'linear-gradient(to bottom, #0c0f14, #0c0f14), linear-gradient(253deg, #d51bff, #00d4ff)'
  //     : 'linear-gradient(to bottom, #fff, #fff), linear-gradient(253deg, #d51bff, #d51bff)',
  // backgroundOrigin: 'border-box',
  // backgroundClip: 'content-box, border-box',
  borderColor: COLORS.DARK_BORDER,
  borderRadius: '8px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ProfileItemPic = styled('img')(({ theme }) => ({
  width: 93,
  height: 131,
  objectFit: 'cover',
  objectPosition: 'top',
  borderRadius: 5,
}));

export const NameContainer = styled('div')(({ theme }) => ({
  '& > p': {
    maxWidth: 93,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));

export const NamePopOverContainer = styled('div')(({ theme }) => ({
  padding: '7px 15px',
}));
